import { render, staticRenderFns } from "./ThirdPartyContact.vue?vue&type=template&id=1bae98fc&scoped=true&"
import script from "./ThirdPartyContact.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bae98fc",
  null
  
)

export default component.exports